import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api from "../api"
import { ParcelModel } from "../api/parcel.api"

export interface ParcelsListState {
    parcels: ParcelModel
    loading: boolean
    error?: string
    parcel: any
    exceptionReasons: any[]
    parcelDestinations: any[]
    parcelStatus: any[]
    parcelPercentage: any
    supplierDetail: any
    suppliers?: Record<string, any>[]
    commonItems?: Record<string, any>[]
    creditParcels: any[]
    creditInvoicedParcels: any[]
}

const initialState: ParcelsListState = {
    parcels: {
        total: 0,
        parcels: []
    },
    exceptionReasons: [],
    loading: false,
    parcel: {},
    parcelDestinations: [],
    parcelStatus: [],
    parcelPercentage: {},
    supplierDetail: [],
    creditParcels: [],
    creditInvoicedParcels: []
}

export interface paginationData {
    page?: number
    pageSize?: number
    warehouse?: string
    invoice_type?: number
    customer?: number

    parcelSearch?: {
        uuid: string
        customer: string
        country: string
        suite: string
        status: {
            value: string
            label: string
        }
        date: string
        split: string
        deleted: string
    }
}

export interface addParcelState {
    awb: string
    user_pin: string
    can_consolidate: number
}

export interface addressChangeState {
    address: string
    id: string
}

export interface MarkExceptionState {
    status: string
    id: string
}

export interface supplierAutocompleteState {
    supplier?: string
}

export interface editParcelState {}

export interface parcelNumber {
    uuid: string
}

export interface parcelByIdState {
    id: number
}

export const loadParcels = createAsyncThunk("parcels/list", async (data: paginationData, thunkAPI) => {
    try {
        return await api.parcel.parcelsList(data)
    } catch (error: any) {
        console.log(error)
    }
})

export const loadCreditParcels = createAsyncThunk(
    "credit/parcels/list",
    async (data: paginationData, thunkAPI) => {
        try {
            const response = await api.parcel.creditParcelsList(data)

            return response
        } catch (error: any) {
            console.log(error)
        }
    }
)

export const loadParcelsById = createAsyncThunk("parcels/detail", async (data: parcelNumber, thunkAPI) => {
    try {
        const response = await api.parcel.parcelById(data)

        if (response.status) {
            return response
        }
    } catch (error: any) {
        console.log(error)
    }
})

export const addParcel = createAsyncThunk("parcels/add", async (addParcelData: addParcelState, thunkAPI) => {
    try {
        const response = await api.parcel.addParcel(addParcelData)
        if (response.status) {
            return response
        }
    } catch (error: any) {
        console.log(error)
    }
})

export const editParcel = createAsyncThunk("parcels/edit", async (addParcelData: editParcelState, thunkAPI) => {
    try {
        const response = await api.parcel.editParcel(addParcelData)
        if (response.status) {
            return response
        }
    } catch (error: any) {
        console.log(error)
    }
})

export const addParcelImage = createAsyncThunk(
    "parcels/add-parcel-image",
    async (addParcelData: editParcelState, thunkAPI) => {
        try {
            const response = await api.parcel.addParcelImage(addParcelData)
            if (response.status) {
                return response
            }
        } catch (error: any) {
            console.log(error)
        }
    }
)

export const deleteParcelImage = createAsyncThunk(
    "parcels/delete-parcel-image",
    async (deleteParcelData: editParcelState, thunkAPI) => {
        try {
            const response = await api.parcel.deleteParcelImage(deleteParcelData)
            if (response.status) {
                return response
            }
        } catch (error: any) {
            console.log(error)
        }
    }
)
export const addressChange = createAsyncThunk(
    "parcels/address-change",
    async (addParcelData: addressChangeState, thunkAPI) => {
        try {
            const response = await api.parcel.addressChange(addParcelData)
            if (response.status) {
                return response
            }
        } catch (error: any) {
            console.log(error)
        }
    }
)

export const loadMarkReasons = createAsyncThunk("parcels/mark-as-exception-reasons", async (thunkAPI) => {
    try {
        const response = await api.parcel.loadMarkReasons()

        return response
    } catch (error: any) {
        console.log(error)
    }
})

export const markAsException = createAsyncThunk(
    "parcels/address-change",
    async (addParcelData: MarkExceptionState, thunkAPI) => {
        try {
            const response = await api.parcel.markAsException(addParcelData)
            if (response.status) {
                return response
            }
        } catch (error: any) {
            console.log(error)
        }
    }
)

export const loadParcelDestinations = createAsyncThunk("parcels/load-parcel-destinations", async (thunkAPI) => {
    try {
        const response = await api.parcel.loadParcelDestinations()

        return response
    } catch (error: any) {
        console.log(error)
    }
})

export const loadParcelStatuses = createAsyncThunk("parcels/load-parcel-statuses", async (thunkAPI) => {
    try {
        const response = await api.parcel.loadParcelStatuses()

        return response
    } catch (error: any) {
        console.log(error)
    }
})

export const loadParcelPercentageById = createAsyncThunk(
    "parcels/percentage",
    async (data: parcelByIdState, thunkAPI) => {
        try {
            const response = await api.parcel.loadParcelPercentageById(data)

            if (response.status) {
                return response
            }
        } catch (error: any) {
            console.log(error)
        }
    }
)

export const supplierAutocomplete = createAsyncThunk(
    "parcels/supplier-autocomplete",
    async (data: supplierAutocompleteState, thunkAPI) => {
        try {
            const response = await api.parcel.supplierAutocomplete(data)
            if (response.status) {
                return response
            }
        } catch (error: any) {
            console.log(error)
        }
    }
)

export const itemsAutocomplete = createAsyncThunk("parcels/items-autocomplete", async (data: "", thunkAPI) => {
    try {
        const response = await api.parcel.itemsAutocomplete()
        if (response.status) {
            return response
        }
    } catch (error: any) {
        console.log(error)
    }
})

export const parcelsSlice = createSlice({
    name: "parcels",
    initialState,

    reducers: {
        clearError: (state: ParcelsListState) => {
            state.error = undefined
        }
    },

    extraReducers: {
        [loadParcels.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadParcels.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.response?.data?.error || ""
        },
        [loadParcels.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.parcels = action.payload?.data?.payload || []
        },
        [loadCreditParcels.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadCreditParcels.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.response?.data?.error || ""
        },
        [loadCreditParcels.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.creditInvoicedParcels = action.payload?.data?.payload?.credit_invoiced_parcels || []
            state.creditParcels = action.payload?.data?.payload?.credit_parcels || []
        },
        [addParcel.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.error) {
                state.error = action.payload?.response?.data?.error
            } else {
                state.error = action.payload?.response?.data?.payload
            }
        },
        [addParcel.fulfilled.toString()]: (state, action) => {
            state.loading = false
        },
        [loadParcelsById.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadParcelsById.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.response?.data?.error || ""
        },
        [loadParcelsById.fulfilled.toString()]: (state, action) => {
            state.loading = false

            state.parcel = action.payload?.data?.payload || {}
        },
        [editParcel.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [editParcel.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.error) {
                state.error = action.payload?.response?.data?.error
            } else {
                state.error = action.payload?.response?.data?.payload
            }
        },
        [editParcel.fulfilled.toString()]: (state, action) => {
            state.loading = false
        },

        [addressChange.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [addressChange.rejected.toString()]: (state, action) => {
            state.loading = false
        },
        [addressChange.fulfilled.toString()]: (state, action) => {
            state.loading = false
        },

        [loadMarkReasons.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadMarkReasons.rejected.toString()]: (state, action) => {
            state.loading = false
        },
        [loadMarkReasons.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.exceptionReasons = action.payload?.data?.payload
        },
        [loadParcelDestinations.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadParcelDestinations.rejected.toString()]: (state, action) => {
            state.loading = false
        },
        [loadParcelDestinations.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.parcelDestinations = action.payload?.data?.payload
        },

        [loadParcelStatuses.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadParcelStatuses.rejected.toString()]: (state, action) => {
            state.loading = false
        },
        [loadParcelStatuses.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.parcelStatus = action.payload?.data?.payload
        },

        [loadParcelPercentageById.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadParcelPercentageById.rejected.toString()]: (state, action) => {
            state.loading = false
        },
        [loadParcelPercentageById.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.parcelPercentage = action.payload?.data?.payload
        },

        [supplierAutocomplete.pending.toString()]: (state, action) => {},
        [supplierAutocomplete.rejected.toString()]: (state, action) => {},
        [supplierAutocomplete.fulfilled.toString()]: (state, action) => {
            state.suppliers = action.payload?.data?.payload
        },

        [itemsAutocomplete.pending.toString()]: (state, action) => {},
        [itemsAutocomplete.rejected.toString()]: (state, action) => {},
        [itemsAutocomplete.fulfilled.toString()]: (state, action) => {
            state.commonItems = action.payload?.data?.payload || []
        }
    }
})

export const { clearError } = parcelsSlice.actions

export default parcelsSlice.reducer
